import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

const $ = window.jQuery;

if (window.jQuery) {
    window.jQuery.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
    });
}


// Use a dynamic import to ensure this happens ONLY after the above is done
async function loadPlugins() {
    // Initialiseer tags direct nadat de import klaar is
    if ($.fn.tagsInput) {
        $('.tags').tagsInput();
        console.log("Tags initialized from Vite bundle");
    }

    // Trigger a global event so your Blade files know it's safe to run
    window.dispatchEvent(new Event('js-vars-ready'));
}

loadPlugins();

import './file-button.js';
import myTable from './mytable.js';
import spinner from './spinner.js';
import myConfirm from './myconfirm.js';

import notify, { notify_reload } from './notify.js';

// Initialization
$(document).ready(function() {

    const tooltipTriggerList = [].slice.call(document.querySelectorAll('.add-tooltip-top, .add-tooltip-bottom'));

    tooltipTriggerList.map(function (el) {
        // Determine placement based on the class name
        const position = el.classList.contains('add-tooltip-top') ? 'top' : 'bottom';

        return new bootstrap.Tooltip(el, {
            placement: position,
            container: 'body',
            trigger: 'hover focus'
        });
    });
    console.log("Add Tooltip Top initialized from Vite bundle");



    function handleResponsiveElements() {
        if($(window).width() <= 1024) {
            $('.table:not(.not-responsive,.table-info)').addClass('table-responsive');
        }
    }
    handleResponsiveElements();
    $(window).resize(handleResponsiveElements); // Run it again if the window is resized

    // 1. Handle Notifications
    if (window.Laravel.notify) {
        // We assume notify() is a global function defined elsewhere
        if (typeof notify === 'function') {
            notify(window.Laravel.notify, window.Laravel.notifyType);
        }
    }

    // 2. Auth Check Interval (Only if NOT in debug mode)
    // if (!window.Laravel.isDebug) {
    //     setInterval(function() {
    //         $.ajax({
    //             type: 'POST',
    //             url: window.Laravel.authCheckUrl,
    //             dataType: 'json',
    //             headers: {
    //                 // Important for Laravel 12 POST requests
    //                 'X-CSRF-TOKEN': window.Laravel.csrfToken
    //             },
    //             success: function(data) {
    //                 if (data.status === 'error') {
    //                     // Bootstrap 5: Lower z-index of all other modals
    //                     $('.modal').css('zIndex', 100);
    //
    //                     // If reAuthModal is a Bootstrap 5 modal instance
    //                     if (window.reAuthModal) {
    //                         window.reAuthModal.show();
    //                         $('#reAuth').css('zIndex', 1050);
    //                     } else {
    //                         // Fallback to jQuery if it's an old BS3/4 modal
    //                         $('#reAuth').modal('show').css('zIndex', 1050);
    //                     }
    //                 }
    //             }
    //         });
    //     }, 20000); // 20 seconds
    // }
});

/**
 * Fixes to enable BS4
 */
// --- 1. DEFINE THE LEGACY SHIMS ---
$.fn.extend({
    bootstrapFourSelect: function () {
        return this.find('.dropdown-menu a').addClass('dropdown-item').end();
    },
    bootstrapFourSelectOptionGroups: function () {
        return this.find('.disabled a')
            .removeClass('dropdown-item')
            .addClass('dropdown-header')
            .end()
            .find('.dropdown-item')
            .addClass('opt')
            .end();
    },
    bootstrapFourForm: function () {
        // Note: BS5 uses mb-3 instead of form-group, so this remains useful
        return this.find('form:not(.form-inline) .mb-3, .form-horizontal .mb-3')
            .addClass('row')
            .end();
    },
    bootstrapFourButton: function () {
        return this.find('.btn-default')
            .removeClass('btn-default')
            .addClass('btn-secondary')
            .end();
    }
});

$(document).ready(function() {
    // 1. EVENT DELEGATION: Fixes dropdowns when they are opened
    $(document.body).on('show.bs.dropdown', '.selectpicker, .bootstrap-select', function () {
        $(this).bootstrapFourSelect();
        // Specifically fix the #files element if it exists
        $('#files').bootstrapFourSelectOptionGroups();
    });

    // 2. AJAX SUCCESS: Re-run fixes if new content is loaded via Ajax
    $(document).ajaxSuccess(function() {
        $(document.body).bootstrapFourForm();
        $(document.body).bootstrapFourButton();
        console.log("Ajax content fixed for Bootstrap 5");
    });

    // 3. INITIAL RUN: Fix everything already on the page
    $(document.body).bootstrapFourForm();
    $(document.body).bootstrapFourButton();
});

window.spinner = spinner;
window.myTable = myTable;
window.notify = notify;
window.notify_reload = notify_reload;
window.myConfirm = myConfirm;
window.$app_url = window.Laravel.url;


